import styled, { css } from 'styled-components';

import responsive from 'theme/responsive';

import PropertyCard from './PropertyCard';

const StyledPropertyCard = styled(PropertyCard)`
    cursor: pointer;

    .card {
        display: flex;
        border-radius: ${(props) => props.theme.corners.box.outside}px;
        overflow: hidden;
        position: relative;
        background-size: cover;
        background-repeat: no-repeat;
        margin-bottom: 20px;
    }

    .inner {
        flex: 1 0 auto;
        height: auto;
        background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 60%,
            rgba(0, 0, 0, 0.85) 100%
        );

        &:before {
            content: '';
            display: block;
            padding-top: 100%;

            ${responsive.sm(css`
                padding-top: 75%;
            `)}
        }
    }

    .price-container {
        bottom: 0;
        right: 0;
        padding: 20px;
        color: ${(props) => props.theme.colours.white};
        position: absolute;
    }

    .price {
        font-size: 22px;
    }

    .title {
        font-size: 18px;
        font-weight: 700;
        display: block;
        color: ${(props) => props.theme.colours.black};
    }

    .subtitle {
        font-size: 18px;
        font-weight: 700;
        display: block;
        color: ${(props) => props.theme.colours.secondary};
    }
`;

export default StyledPropertyCard;
